import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';

class AdminProductionsIndexController extends Controller {
  @service api;
  @service store;
  @service router;

  @action
  createProduction() {
    this.router.transitionTo('admin.productions.create');
  }

  @action
  viewProduction(production) {
    this.router.transitionTo('admin.productions.view', production.slug);
  }

  @dropTask
  *loadProductions() {
    const params = {
      include: 'client',
      filter: {
        company_id: 192,
      },
      count: 50,
    };

    const response = yield this.api.get('productions', { params });
    this.store.pushPayload(response);
    return response.data.map(({ id }) => this.store.peekRecord('production', id));
  }
}

export default AdminProductionsIndexController;
